import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import { createMyOrganization } from "../../api/onboarding";
import * as authService from "../../api/auth";
import { storeAuthToken } from "../../utils/storage";
import useAuth from "../../hooks/useAuth";
import { useNotify } from "../../utils/useNotify";

export default function CreateFarm() {
  const navigate = useNavigate();
  const { refreshProfile } = useAuth();
  const notify = useNotify();
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await createMyOrganization(name.trim());
      const { token } = await authService.refreshJwt();
      storeAuthToken(token);
      await refreshProfile();
      notify.success("Organization created. Next, confirm your farm details.");
      navigate("/farm-setup", { replace: true });
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
          err?.message ||
          "Could not create organization."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", pt: 4, px: 2 }}>
      <Card sx={{ maxWidth: 480, width: "100%" }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Create your farm
          </Typography>
          <Typography color="text.secondary" paragraph>
            Choose a name for your organization. You can invite your team after
            this step.
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {typeof error === "string" ? error : JSON.stringify(error)}
            </Alert>
          )}
          <form onSubmit={onSubmit}>
            <TextField
              label="Farm / organization name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              required
              margin="normal"
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 2 }}
              disabled={loading || !name.trim()}
            >
              {loading ? "Creating…" : "Create"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
